
import { printHumanFloat } from "@/utils/pretty-print";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data(){
		return{
			amount: 0.0,
			isSaving: false
		};
	},
	props: {
		value: {
			type: Number,
			required: true
		},
		title: {
			type: [String, Object as ()=>TranslateResult],
			required: true,
		},
		handler: {
			type: Function,
			required: true
		}
	},
	computed: {
		valueStr():string{
			return printHumanFloat(this.value);
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			if (this.isSaving) return false;
			this.isSaving = true;
			try{
				await this.handler(this.amount);
				this.$emit("refresh");
				this.close();
			}catch(err){

			}
			this.isSaving = false;
		}
	},
	mounted(){
		this.amount = this.value;
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
